import { Attributes, List, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';
import InvestorInvestmentInternalApproval from './InvestorInvestmentInternalApproval';
import { SourceOfFundsType } from './SourceOfFundsType.enum';
import InvestorInvestmentClientApproval from './InvestorInvestmentClientApproval';

export default class InvestorInvestmentApproval extends TemporalEntity {
    static typeName = "InvestorInvestmentApproval";

    constructor() {
        super();
        this.makeObservable();
    }

    public investorInvestmentApprovalId: number = 0;

    @Rules.Required()
    public investorInvestmentId: number | null = null;

    public createdBy: number = 0;

    @Attributes.Date()
    public createdOn: Date = new Date();

    @Attributes.Nullable()
    public termsAndConditionsFileDescriptorId: number | null = null;

    @Rules.Required()
    public participationAgreementFileDescriptorId: number | null = null;

    public internalApprovals = new List(InvestorInvestmentInternalApproval);

    public clientApprovals = new List(InvestorInvestmentClientApproval);

    public sourceOfFunds: SourceOfFundsType | null = null;

    @Attributes.Nullable()
    public proofOfPaymentFileDescriptorId: number | null = null;

    @Rules.StringLength(20)
    public accountNumber: string = "";

    @Attributes.ChildObject(Model.UserEvent, true)
    public activated: Model.UserEvent = Model.UserEvent.None();

    @Attributes.ChildObject(Model.UserEvent, true)
    public completed: Model.UserEvent = Model.UserEvent.None();

    @Attributes.ChildObject(Model.UserEvent, true)
    public clientApproved: Model.UserEvent = Model.UserEvent.None();

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public lookup: LookupFields = new LookupFields();

    // Client only properties / methods

    public get isActive() {
        return this.activated.on != null;
    }

    public get clientActivationStatus() {
        if (this.clientApproved.on != null) {
            if (this.clientApprovals.length < this.lookup.requiredClientAuthorisations) {
                return "Awaiting additional approvals";
            } else {
                return "Approved";
            }
        } else {
            return "Awaiting initial approval";
        }
    }

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.accountNumber) {
            return "New approval";
        } else {
            return this.accountNumber;
        }
    }
}

export class LookupFields {

    @Attributes.Integer()
    public requiredClientAuthorisations: number = 0;

    // Client only properties / methods
}